'use strict';

import Alert from 'bootstrap/js/src/alert';

/**
 * @example
 * <vz-alert class="d-none" name="the-name-used-in-the-cookie"></vz-alert>
 */
class VZAlert extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.removeAlert = this.removeAlert.bind(this);
        this.showAlert = this.showAlert.bind(this);

        this.hasCookie().then(this.showAlert).catch(this.removeAlert);

        this.addEventListener('close.bs.alert', this.onClose.bind(this));
    }

    disconnectedCallback() {
        this.addEventListener('close.bs.alert', this.onClose);
    }

    hasCookie() {
        const name = `${this.getAttribute('name')}=`;
        return new Promise((resolve, reject) => {
            const cookies = document.cookie.split(';');
            return !cookies.find((cookie) => cookie.indexOf(name) !== -1) ? resolve() : reject(); // eslint-disable-line no-promise-executor-return
        });
    }

    onClose() {
        const expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + 365 * 24 * 60 * 60 * 1000);

        const cookieString = `${this.getAttribute('name')}=true; expires=${expirationDate.toGMTString()}; path=/; secure; sameSite=None`;
        document.cookie = cookieString;
    }

    removeAlert() {
        return this.remove();
    }

    showAlert() {
        const instance = new Alert(this); // eslint-disable-line
        this.classList.remove('d-none');
        this.classList.add('d-flex');
    }
}

export default window.customElements.get('vz-alert') || VZAlert;
if (!window.customElements.get('vz-alert')) {
    window.customElements.define('vz-alert', VZAlert);
}
